<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid">
            <div class="md:col-8 sm:col-12 comp-grid">
              <div class="card">
                <div class="text-xl text-primary font-bold">Add Programme</div>
              </div>
              <Breadcrumb :home="{
                icon: 'pi pi-arrow-left text-lg mr-3',
                label: 'Back',
                command: () => {
                  $router.go(-1);
                },
              }" :model="[
                  {
                    label: 'Programmes',
                    to: '/institution_programmes',
                  },
                  {
                    label: 'Add New',
                    to: '/institution_programmes/add',
                  },
                ]" />
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="sm:col-12 md:col-8 comp-grid">
            <div class="card nice-shadow-18">
              <div>
                <form ref="observer" tag="form" @submit.prevent="startSaveRecord()" @reset="resetForm">
                  <div class="grid">
                    <div class="col-12">
                      <div class="mb-2 font-bold text-sm">
                        Select Programme *
                      </div>
                      <div id="ctrl-caps_programme_id-holder">
                        <api-data-source @loaded="(response) =>
                            mapOptionField(response, 'caps_programme_id')
                          " api-path="components_data/accredited_institution_programmes_id_option_list">
                          <template v-slot="req">
                            <Dropdown class="w-full" :class="getErrorClass('caps_programme_id')" :loading="req.loading"
                              optionLabel="label" optionValue="value" ref="ctrlcaps_programme_id"
                              v-model="formData.caps_programme_id" :options="req.response" label="Select Programme"
                              placeholder="Select a value ..." :filter="true">
                            </Dropdown>
                          </template>
                        </api-data-source>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="mb-2 font-bold text-sm">
                        Program Department
                      </div>
                      <div id="ctrl-institution_school_id-holder">
                        <api-data-source @loaded="(response) =>
                            mapOptionField(response, 'institution_school_id')
                          " api-path="components_data/institution_school_id_option_list">
                          <template v-slot="req">
                            <Dropdown class="w-full" :class="getErrorClass('institution_school_id')"
                              :loading="req.loading" optionLabel="label" optionValue="value"
                              ref="ctrlinstitution_school_id" v-model="formData.institution_school_id"
                              :options="req.response" label="Program Department / School"
                              placeholder="Select a value ...">
                            </Dropdown>
                          </template>
                        </api-data-source>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="mb-2 font-bold text-sm">
                        Programme Description
                      </div>
                      <div id="ctrl-programme_description-holder">
                        <Textarea :class="getErrorClass('programme_description')" class="w-full"
                          ref="ctrlprogramme_description" rows="3" v-model="formData.programme_description"
                          placeholder="Enter Programme Description" type="textarea">
                    </Textarea>
                      </div>
                    </div>
                    <div class="md:col-6 col-12">
                      <div class="mb-2 font-bold text-sm">Cut Off Point</div>
                      <div id="ctrl-cut_off_point-holder">
                        <InputText ref="ctrlcut_off_point" v-model.trim="formData.cut_off_point" label="Cut Off Point"
                          type="number" placeholder="Enter Cut Off Point" step="any" max="24" min="6" class="w-full"
                          :class="getErrorClass('cut_off_point')">
                        </InputText>
                      </div>
                    </div>
                    <div class="md:col-6 col-12">
                      <div class="mb-2 font-bold text-sm">
                        Available Slots *
                      </div>
                      <div id="ctrl-slots-holder">
                        <InputText ref="ctrlslots" v-model.trim="formData.slots" label="Available Slots" type="number"
                          placeholder="Enter Available Slots" step="any" class="w-full" :class="getErrorClass('slots')">
                        </InputText>
                      </div>
                    </div>
                    <div class="md:col-6 col-12">
                      <div class="mb-2 font-bold text-sm">
                        Programme Campuses
                      </div>
                      <div id="ctrl-programme_campuses-holder">
                        <api-data-source @loaded="(response) =>
                            mapOptionField(response, 'programme_campuses')
                          "
                          :api-path="`components_data/programme_campuses_option_list?caps_programme_id=${formData.caps_programme_id}`">
                          <template v-slot="req">
                            <MultiSelect class="w-full" :class="getErrorClass('programme_campuses')" optionLabel="label"
                              optionValue="value" ref="ctrlprogramme_campuses" v-model="formData.programme_campuses"
                              :options="req.response" label="Programme Campuses">
                            </MultiSelect>
                          </template>
                        </api-data-source>
                      </div>
                    </div>
                    <div class="md:col-6 col-12">
                      <div class="mb-2 font-bold text-sm">
                        Programme Sessions
                      </div>
                      <div id="ctrl-programme_sessions-holder">

                        <api-data-source @loaded="(response) =>
                            mapOptionField(response, 'programme_sessions')
                          " :api-path="`components_data/caps_programme_sessions_option_list`">
                          <template v-slot="req">
                            <MultiSelect class="w-full" :class="getErrorClass('programme_sessions')" optionLabel="label"
                              optionValue="value" ref="ctrlprogramme_sessions" v-model="formData.programme_sessions"
                              :options="req.response" label="Programme Sessions">
                            </MultiSelect>
                          </template>
                        </api-data-source>

                      </div>
                    </div>
                    <div class="md:col-6 col-12">
                      <div class="mb-2 font-bold text-sm">
                        Programme Requisites (if applicable)
                      </div>
                      <div id="ctrl-programme_requisites-holder">

                        <api-data-source @loaded="(response) =>
                            mapOptionField(response, 'programme_requisites')
                          " :api-path="`components_data/caps_programme_requisites_option_list`">
                          <template v-slot="req">
                            <MultiSelect class="w-full" :class="getErrorClass('programme_requisites')"
                              optionLabel="label" optionValue="value" ref="ctrlprogramme_requisites"
                              v-model="formData.programme_requisites" :options="req.response"
                              label="Programme Requisites">
                            </MultiSelect>
                          </template>
                        </api-data-source>

                      </div>
                    </div>
                    <div class="md:col-6 col-12">
                      <div class="mb-2 font-bold text-sm">
                        Programme Required SHS Courses (optional)
                      </div>
                      <div id="ctrl-programme_required_electives-holder">

                        <api-data-source @loaded="(response) =>
                            mapOptionField(response, 'programme_required_electives')
                          " :api-path="`components_data/caps_shs_courses_option_list`">
                          <template v-slot="req">
                            <MultiSelect class="w-full" :class="getErrorClass('programme_required_electives')"
                              optionLabel="label" optionValue="value" ref="ctrlprogramme_required_electives"
                              v-model="formData.programme_required_electives" :options="req.response"
                              label="Programme Required Electives">
                            </MultiSelect>
                          </template>
                        </api-data-source>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mt-3">
                        <div class="mb-1 mx-2 text-blue-500 font-bold text-md">
                          Programme Options
                        </div>
                        <small class="mx-2 text-xs text-primary">You can add up to 10 additional programme options for
                          interested applicants to choose from</small>

                        <div class="mt-3">
                          <addprogrammeoptions-page is-sub-page ref="addprogrammeoptionsForm"
                            :show-submit-button="false" v-if="ready"></addprogrammeoptions-page>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="showSubmitButton" class="text-center my-3">
                    <Button class="p-button-primary" type="submit" label="Submit" icon="pi pi-send" :loading="saving" />
                  </div>
                </form>
                <slot :submit="submit" :saving="saving"></slot>
              </div>
            </div>
          </div>
          <div class="sm:col-12 md:col-4">
            <div class="sticky-item"><file-svg-page></file-svg-page></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { mapActions, mapGetters, mapState } from "vuex";
import { AddPageMixin } from "../../mixins/addpage.js";
import { PageMixin } from "../../mixins/page.js";
import fileSvgPage from "../custom/file_svg.vue";
import addprogrammeoptionsPage from "../institution_programmes/add_programme_options.vue";
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  name: "addInstitutionprogrammesPage",
  components: { addprogrammeoptionsPage, fileSvgPage },
  mixins: [PageMixin, AddPageMixin],
  props: {
    pageName: {
      type: String,
      default: "institution_programmes",
    },
    routeName: {
      type: String,
      default: "institution_programmesadd",
    },
    apiPath: {
      type: String,
      default: "institution_programmes/add",
    },
  },
  data() {
    return {
      formData: {
        caps_programme_id: "",
        institution_school_id: "",
        programme_description: "",
        cut_off_point: "",
        slots: "",
        programme_campuses: [],
        programme_sessions: [],
        programme_required_electives: [],
        programme_requisites: [],
      },
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Add New Institution Programmes";
      },
    },
  },
  validations() {
    let formData = {
      caps_programme_id: { required },
      institution_school_id: {},
      programme_description: {},
      cut_off_point: {},
      slots: { required },
      programme_campuses: {},
      programme_sessions: {},
      programme_required_electives: {},
      programme_requisites: {},
    };
    return { formData };
  },
  methods: {
    ...mapActions("institution_programmes", ["saveRecord"]),
    async startSaveRecord() {
      this.submitted = true;
      const isFormValid = !this.v$.$invalid;
      if (!isFormValid) {
        this.flashMsg("Form is invalid", "", "error");
        return;
      }
      this.saving = true;
      let payload = this.normalizedFormData();
      payload.programme_options =
        this.$refs.addprogrammeoptionsForm.arrFormData;
      let url = this.apiUrl;
      let data = { url, payload };
      this.saveRecord(data).then(
        (response) => {
          this.record = response.data ?? {};
          this.id = this.record["institution_programme_id"] ?? null;
          this.saving = false;
          this.submitted = false;
          this.closeDialogs(); // close page dialog that if opened
          this.flashMsg(this.msgAfterSave);
          this.$emit("submitted", this.record);
          if (this.redirect) this.navigateTo(`/institution_programmes`);
        },
        (response) => {
          this.saving = false;
          this.showPageRequestError(response);
        }
      );
    },
    resetForm() {
      // this.formData = {};
      // this.updateFormData();
      //this.$EventBus.$emit("resetForm");
    },
    getErrorClass(field) {
      return {
        "p-invalid": this.v$.formData[field].$invalid && this.submitted,
      };
    },
  },
  watch: {},
  async mounted() { },
  async created() { },
};
</script>
<style scoped></style>
